var render, staticRenderFns
import script from "./QSnapshotAgencyLeaderboardDataTable.vue?vue&type=script&lang=js&"
export * from "./QSnapshotAgencyLeaderboardDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QSnapshotAgencyLeaderboardDataTable.vue?vue&type=style&index=0&id=47188282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47188282",
  null
  
)

export default component.exports